/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createAction, props } from "@ngrx/store";
import { AnnotationSettingsActionsNames } from "./annotation-settings-action-names";
import { AnnotationSettings, AnnotationSettingsTabType, CurrentSelectionResult, RevitInformation } from "../../models/annotation-settings";

export const GetAnnotationSettingsFromXMLFile = createAction(
    AnnotationSettingsActionsNames.GetAnnotationSettingsFromXMLFile()
);

export const GetAnnotationSettingsFromXMLFileSuccess = createAction(
    AnnotationSettingsActionsNames.GetAnnotationSettingsFromXMLFileSuccess(),
    props<{ response: AnnotationSettings }>()
);

export const SaveAnnotationSettingsToXmlFile = createAction(
    AnnotationSettingsActionsNames.SaveAnnotationSettingsToXmlFile(),
    props<{ annotationSettings: AnnotationSettings }>()
);

export const SaveAnnotationSettingsToXmlFileSuccess = createAction(
    AnnotationSettingsActionsNames.SaveAnnotationSettingsToXmlFileSuccess(),
    props<{ response: any }>()
);

export const GetRevitInformation = createAction(
    AnnotationSettingsActionsNames.GetRevitInformation()
);

export const GetRevitInformationSuccess = createAction(
    AnnotationSettingsActionsNames.GetRevitInformationSuccess(),
    props<{ response: RevitInformation }>()
);

export const GetTagLocationPath = createAction(
    AnnotationSettingsActionsNames.GetTagLocationPath()
);

export const GetTagLocationPathSuccess = createAction(
    AnnotationSettingsActionsNames.GetTagLocationPathSuccess(),
    props<{ response: string }>()
);

export const GetFittingsTagLocationPath = createAction(
  AnnotationSettingsActionsNames.GetFittingsTagLocationPath()
);

export const GetFittingsTagLocationPathSuccess = createAction(
  AnnotationSettingsActionsNames.GetFittingsTagLocationPathSuccess(),
  props<{ response: string }>()
);

export const IsCurrentSelectionValid = createAction(
    AnnotationSettingsActionsNames.IsCurrentSelectionValid()
);

export const IsCurrentSelectionValidSuccess = createAction(
    AnnotationSettingsActionsNames.IsCurrentSelectionValidSuccess(),
    props<{ response: CurrentSelectionResult }>()
);

export const ApplyData = createAction(
    AnnotationSettingsActionsNames.ApplyData(),
    props<{ selectedTab: AnnotationSettingsTabType}>()
);

export const ApplyDataSuccess = createAction(
    AnnotationSettingsActionsNames.ApplyDataSuccess(),
    props<{ response: string }>()
);